import React, { useRef } from 'react'
import PrimaryTitle from '../../../../components/PrimaryTitle'
import { inject, observer } from 'mobx-react'
import { Input, DateInput, Textarea } from '../../../../components/formComponents'
import { Form, Button } from 'react-bootstrap'
import DocumentStore from '../../../../store/documentForm.store'
import PropTypes from 'prop-types'
import t from '../../../../service/translate.service'
import ContractSelector from '../../../../components/contractSelector'
import { buildValidators } from '../../../../service/validate'
import { Alert } from 'antd'
import { useNavigate } from 'react-router-dom'

const Key = (props) => {
  const inputRefs = useRef({})
  const { model, setVal, setSelectedKeys, keyReorderValidators, keyOptions, keyReorderValidatorInputs, validateKeysObject, errorsList, errorListVoice, submitted } = DocumentStore
  const { file } = props
  const validatorBlur = buildValidators({...validateKeysObject, ...keyReorderValidatorInputs}, true)
  const navigate = useNavigate()
  
  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'date') {
        if (validatorBlur[key] && validatorBlur[key](item?.props?.selected, item?.props['aria-label'])) {
          let err = validatorBlur[key](item?.props?.selected, item?.props['aria-label'])
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.setFocus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      } else if (key === 'newKeyButton') {
        if (model['selectedKeys']?.length === 0) {
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {t.KEY_FORM_ERROR}
            </button>
          )
        }
      } else {
        if (validatorBlur[key] && validatorBlur[key](item.value, item.ariaLabel)) {
          let err = validatorBlur[key](item.value, item.ariaLabel)
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      }    
    }
    return errors
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    DocumentStore.submit(file.fileName, props.contractStore.selectedContract.contractNumber, generateErrorList)
  }
  const getAttrs = field => {
    return {
      value: model[field],
      onChange: e => setVal(field, e.target.value),
      validate: keyReorderValidators[field],
      blurValidate: validatorBlur[field]
    }
  }


  const AlertContent = () => {
    if (errorsList?.length > 0) {
      if (props?.documentFormHolderRef) {
        props.documentFormHolderRef?.current?.scrollTo(0,0)
      }
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }

  return (
    <div className='form-holder'>
      <PrimaryTitle title={t.KEY} />
      {submitted && (
        <AlertContent />
      )}
      <Form>
        <ContractSelector required={true} label padding page='documents' aria-label={t.SELECT_CONTRACT} />
        <h3 className='inputs-text'>{t.NAME_CHANGE_HEAD_ONE}</h3>
        <Input ref={(el) => (inputRefs.current['fullName'] = el)} required={true} autoComplete="name" name='fullName' {...getAttrs('fullName')} label={t.DIGITAL_CONTRACT_FORM_FULL_NAME} aria-label={t.FULL_NAME} />
        <h3 className='inputs-text'>{t.KEY_HEAD_ONE}</h3>
        <ul className='selected-inputs-holder'>
          {model['selectedKeys'].map((selectedKey) => (
            <li key={selectedKey.key}>
              <div className='selected-input-header'>
                {selectedKey.key.includes('additional') ? (
                  <Input
                    ref={(el) => (inputRefs.current[`${selectedKey.key}Head`] = el)}
                    validate={keyReorderValidators[`${selectedKey.key}Head`]}
                    bluerValidate={validatorBlur[`${selectedKey.key}Head`]}
                    styles={{ width: '100%', maxWidth: '280px', marginBottom: '0' }}
                    value={selectedKey.head}
                    onChange={(e) => setSelectedKeys(selectedKey, 'input-change', 'head', e.target.value)}
                    label={t.KEY_HEAD_G}
                    aria-label={t.KEY_HEAD_G}
                  />
                ) : (
                  <h3 className='inputs-text'>{selectedKey.head}</h3>
                )}
                <button 
                  onClick={() => { setSelectedKeys(selectedKey, 'remove') }} 
                  type='button'
                  aria-label={t.REMOVE_KEY}
                >
                  x
                </button>
              </div>
  
              <div className='inputs-holder'>
                <Input ref={(el) => (inputRefs.current[`${selectedKey.key}KeyNumber`] = el)} required={true} name={`${selectedKey.key}KeyNumber`} bluerValidate={validatorBlur[`${selectedKey.key}KeyNumber`]} validate={keyReorderValidators[`${selectedKey.key}KeyNumber`]} value={selectedKey.keyNumber} onChange={(e) => setSelectedKeys(selectedKey, 'input-change', 'keyNumber', e.target.value)} label={t.DIGITAL_CONTRACT_FORM_KEY_NUMBER} aria-label={t.KEY_NUMBER} />
                <Input ref={(el) => (inputRefs.current[`${selectedKey.key}Manufacturer`] = el)} required={true} name={`${selectedKey.key}Manufacturer`} bluerValidate={validatorBlur[`${selectedKey.key}Manufacturer`]}  validate={keyReorderValidators[`${selectedKey.key}Manufacturer`]} value={selectedKey.manufacturer} onChange={(e) => setSelectedKeys(selectedKey, 'input-change', 'manufacturer', e.target.value)} label={t.DIGITAL_CONTRACT_FORM_MANUFACTURER} aria-label={t.MANUFACTURER} />
                <Input ref={(el) => (inputRefs.current[`${selectedKey.key}Quantity`] = el)} required={true} name={`${selectedKey.key}Quantity`} bluerValidate={validatorBlur[`${selectedKey.key}Quantity`]} validate={keyReorderValidators[`${selectedKey.key}Quantity`]} value={selectedKey.quantity} onChange={(e) => setSelectedKeys(selectedKey, 'input-change', 'quantity', e.target.value)} label={t.DIGITAL_CONTRACT_DESCRIPTION_QUANTITY} aria-label={t.QUANTITY} />
              </div>
  
              <div className='line' />
            </li>
          ))}
        </ul>
  
        <div className='new-key-select-holder'>
          <button onBlur={() => setVal('keyFormError', t.KEY_FORM_ERROR)} ref={(el) => (inputRefs.current['newKeyButton'] = el)} onClick={() => {
            setVal('showOptions', !model['showOptions'])
          }} className='open-options-holder' type='button' aria-label={t.ADD_NEW_KEY}><span>+</span>{t.KEY_ADD_NEW} *</button>
          <div style={{ marginTop: `${model['keyFormError'] === '' ? 0 : '-12px'}`, marginBottom: `${model['keyFormError'] === '' ? 0 : '20px'}` }} className='error-message' role="alert">
            {model['keyFormError']}
          </div>
  
          <ul 
            style={{ display: `${model['showOptions'] ? 'flex' : 'none'}` }} 
            className='options-holder'
            aria-live="polite"
          >
            {keyOptions.map((option) => {
              if ((!model['selectedKeys'].find((selectedKey) => selectedKey.key === option.key)) && (!option.key.includes('additional') || model['additionalLength'] < 2)) {
                return (
                  <li key={option.key}>
                    <button 
                      onClick={() => {
                        setVal('showOptions', false)
                        setSelectedKeys(option, 'add')
                      }} 
                      type='button'
                      aria-label={`${t.ADD_KEY} ${option.value}`}
                    >
                      {option.value}
                    </button>
                  </li>
                )
              }
            })}
          </ul>
        </div>
  
        <Textarea
          ref={(el) => (inputRefs.current['keyReorderReason'] = el)}
          name='keyReorderReason' 
          {...getAttrs('keyReorderReason')} 
          label={t.DIGITAL_CONTRACT_FORM_REORDER_REASON + '*'} 
          aria-label={t.REORDER_REASON}
        />
  
        <p className='input-para'>{t.KEY_PARA_ONE}</p>
        <Input ref={(el) => (inputRefs.current['place'] = el)} autoComplete="address-level2" name='place' {...getAttrs('place')} label={t.DIGITAL_CONTRACT_FORM_PLACE + '*'} aria-label={t.PLACE} />
        <DateInput blurValidate={validatorBlur['date']} ref={(el) => (inputRefs.current['date'] = el)} name='date' value={model['date']} onChange={(date) => setVal('date', date)} validate={keyReorderValidators['date']} label={t.DIGITAL_CONTRACT_FORM_DATE + '*'} aria-label={t.DATE} />
        <Form.Group className='actions text-center'>
          <div className='group'>
            <button
              className='button primary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                onSubmit(e)
              }}
              aria-label={t.SUBMIT_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_SEND}
            </button>
            <a
              href='/documents'
              className='button secondary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                DocumentStore.onCloseForm()
                navigate('/documents')
              }}
              style={{
                textDecoration: 'none',
                color: 'unset'
              }}
              aria-label={t.CANCEL_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_CANCEL}
            </a>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}

Key.propTypes = {
  file: PropTypes.object.isRequired,
  contractStore: PropTypes.object
}

export default inject('contractStore')(observer(Key))
